export const subRequest = {
  TENANT_BY_DOMAIN: "/api/v7/user/tenants/by-domain?domain=:domain",
  SUB_PLAN:
    "/api/v6/businesses/subscriptionPlans?page=0&size=100&q=countryCode::country",
  INIT_PAYMENT: "/subscription/initiate",
  VERIFY_PAYMENT: "/subscription/status?reference=:reference",
  VERIFY_PROMO_CODE: "/api/v6/subscriptionCampaigns",
  INIT_DISCOUNT_PAYMENT: "/subscription/initiate_discount_subscription",
};
